import useBreakpoint from '@/hooks/useBreakpoint';
import BreadcrumbPaginaMobile from './Designs/Mobile';
import BreadcrumbPaginaDesktop from './Designs/Desktop';

export type BreadcrumbPaginaProps = {
  $nomePaginaAtual: string;
};

export default function BreadcrumbPagina(props: BreadcrumbPaginaProps) {
  const { breakpoint } = useBreakpoint();

  return breakpoint === 'mobile' ? (
    <BreadcrumbPaginaMobile {...props} />
  ) : (
    <BreadcrumbPaginaDesktop {...props} />
  );
}
